import { useState, useEffect } from 'react'

// Global state outside hook for synchronization across all instances
let globalTimeLeft = 643 // 10 minutes 43 seconds
const listeners = new Set<React.Dispatch<React.SetStateAction<number>>>()
let intervalId: NodeJS.Timeout | null = null

const startInterval = () => {
  if (!intervalId) {
    intervalId = setInterval(() => {
      globalTimeLeft = Math.max(0, globalTimeLeft - 1)
      listeners.forEach((set) => set(globalTimeLeft))
      if (globalTimeLeft === 0 && intervalId) {
        clearInterval(intervalId)
      }
    }, 1000)
  }
}

export const useCountdown = () => {
  const [timeLeft, setTimeLeft] = useState(globalTimeLeft)

  useEffect(() => {
    listeners.add(setTimeLeft)
    startInterval()
    return () => {
      listeners.delete(setTimeLeft)
      if (listeners.size === 0 && intervalId) {
        clearInterval(intervalId)
        intervalId = null
      }
    }
  }, [])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60

  return {
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0'),
    isExpired: timeLeft === 0,
  }
}
